import React from 'react'
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link
} from 'react-router-dom'

// import GATracking from './gaTracking'
import { Query } from 'react-apollo'
import { CHECK_AUTH } from 'operations/Auth'
import { ME } from 'operations/User'

import './styles/index.css'

import { Header } from './components/Header'
// import { SubHeader } from './components/SubHeader'

import { Dashboard } from './containers/Dashboard'
import { Images } from './containers/Images'
import { Settings } from './containers/Settings'
import { Account } from './containers/Account'

import { Unauthorized } from './containers/Unauthorized'
import SignUp from 'containers/Unauthorized/SignUp'
import Login from 'containers/Unauthorized/Login'
import Forgot from 'containers/Unauthorized/Forgot'
import Verify from 'containers/Unauthorized/Verify'
import Reset from 'containers/Unauthorized/Reset'

import Banner from 'components/Banner'

import Refresh from './Refresh'
import moment from 'moment'

export const Routes = () => (
    <React.Fragment>
        <Router>
            <Route path='/:page/:token'>
                {({ match }) => (
                    
                <Query query={ CHECK_AUTH }>
                    {({ loading, error, data: { isAuthenticated } }) => {
                        if (loading) return null
                        if (error) return `Error! ${error.message}`

                        const page = match && match.params && match.params.page ? match.params.page : null

                        if (isAuthenticated && page !== 'v') {

                            return (
                                <Query query={ ME }>
                                    {({ loading, error, data }) => {
                                        if (loading) return 'Loading...';
                                        if (error) return `Error! ${error.message}`;
                                        console.log(data)

                                        const { isVerified, firstName, account: { stripeCustomerId, trialEnd } } = data.me

                                        const downShift = !isVerified || (!stripeCustomerId && trialEnd < moment())

                                        return (
                                            <div className='wrapper__container'>
                                                {
                                                    !isVerified ? (
                                                        <Banner>Hi there{ firstName ? ' ' + firstName : '' }! We just sent you a quick email to activate your account. It should be in your inbox, but please check your spam if you don't see it.</Banner>
                                                    ) : null
                                                }
                                                {
                                                    !stripeCustomerId && trialEnd < moment() ? (
                                                        <Banner trial>Woah{ firstName && ' ' + firstName }, you rocked that 14 day trial! Add your <Link to='/account'>billing info</Link> so we can continue serving you.</Banner>
                                                    ) : null
                                                }  
                                                <div className={`wrapper${ downShift ? ' wrapper--downShift' : '' }`}>
                                                    <Header />

                                                    <div className='content__wrapper'>
                                    
                                                        {/* <SubHeader /> */}
                                    
                                                        <div className='content__container'>                                         
                                                            <Switch>
                                                                <Route exact path='/' component={ Dashboard } />
                                                                <Route path='/images' component={ Images } />
                                                                <Route path='/settings' component={ Settings } />
                                                                <Route path='/account' component={ Account } />
                                    
                                                            </Switch>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    }}
                                </Query>
                            )

                        }

                        return (
                            <Unauthorized>
                                <Switch>                                
                                    <Route exact path='/' component={ Login } />
                                    <Route path='/signup' component={ SignUp } />
                                    <Route path='/forgot' component={ Forgot } />
                                    <Route path='/v/:token' component={ Verify } />
                                    <Route path='/r/:token' component={ Reset } />
                                </Switch>
                            </Unauthorized>
                        )

                    }}
                </Query>
                )}    
            </Route>
        </Router>
        <Refresh />
    </React.Fragment>
)


// WEBPACK FOOTER //
// ./src/Routes.js